import km from 'keymirror'
import _ from 'underscore'

//TMR ==> ToManyRequests
export default _.extend({
  GOODS_LIST_ATTR_ID_FOR_COURSE_NUM: 10001,
  GOODS_LIST_ATTR_ID_FOR_COURSE_TRY_URL: 10002,
  GOODS_LIST_SHOW_TYPE_COURSE: 1,
}, km({
  BILLBOARDS_GET_LIST_START: null,
  BILLBOARDS_GET_LIST_SUCCESS: null,
  BILLBOARDS_GET_LIST_ERROR: null,
  BILLBOARDS_GET_LIST_ERROR_EMPTY: null,
  BILLBOARDS_GET_LIST_ERROR_TMR: null,

  RECOMMEND_GET_LIST_START: null,
  RECOMMEND_GET_LIST_SUCCESS: null,
  RECOMMEND_GET_LIST_ERROR: null,
  RECOMMEND_GET_LIST_ERROR_EMPTY: null,
  RECOMMEND_GET_LIST_ERROR_TMR: null,

  BANNER_GET_LIST_START: null,
  BANNER_GET_LIST_SUCCESS: null,
  BANNER_GET_LIST_ERROR: null,
  BANNER_GET_LIST_ERROR_EMPTY: null,
  BANNER_GET_LIST_ERROR_TMR: null,

  SHOPS_GET_LIST_START: null,
  SHOPS_GET_LIST_SUCCESS: null,
  SHOPS_GET_LIST_ERROR: null,
  SHOPS_GET_LIST_ERROR_EMPTY: null,
  SHOPS_GET_LIST_ERROR_TMR: null,

  POPULAR_GET_LIST_START: null,
  POPULAR_GET_LIST_SUCCESS: null,
  POPULAR_GET_LIST_ERROR: null,
  POPULAR_GET_LIST_ERROR_EMPTY: null,
  POPULAR_GET_LIST_ERROR_TMR: null,

  ITEM_GET_HOME_RECOMMEND_START: null,
  ITEM_GET_HOME_RECOMMEND_SUCCESS: null,
  ITEM_GET_HOME_RECOMMEND_ERROR: null,
  ITEM_GET_HOME_RECOMMEND_ERROR_EMPTY: null,
  ITEM_GET_HOME_RECOMMEND_ERROR_TMR: null,

  ITEM_GET_DETAIL_START: null,
  ITEM_GET_DETAIL_SUCCESS: null,
  ITEM_GET_DETAIL_ERROR: null,
  ITEM_GET_DETAIL_ERROR_EMPTY: null,
  ITEM_GET_DETAIL_ERROR_TMR: null,

  COMPANY_HOME_RECOMMEND_GET_LIST_START: null,
  COMPANY_HOME_RECOMMEND_GET_LIST_SUCCESS: null,
  COMPANY_HOME_RECOMMEND_GET_LIST_ERROR: null,
  COMPANY_HOME_RECOMMEND_GET_LIST_ERROR_EMPTY: null,
  COMPANY_HOME_RECOMMEND_GET_LIST_ERROR_TMR: null,

  QRCODE_QUERY_SUCCESS: null,
  QRCODE_QUERY_ERROR: null,
  HOME_GETTOPICGATHERLIST_SUCCESS: null,
  HOME_GETTOPICGATHERLIST_ERROR: null,
  HOME_GETHOMEMENUS_SUCCESS: null,
  HOME_GETHOMEMENUS_ERROR: null,

    /*yeoman-template-point-1*/
}))
